module.exports = __webpack_public_path__ + "static/ArialRegular-0ba3afee4ca77cfd0ef1757fbec15ef1.ttf";